import { t } from 'i18next';
import { TFunction } from 'react-i18next';

export const buildTScoped =
    (keyPath: string): typeof t =>
    (...args: Parameters<typeof t>) => {
        const [key, ...otherArgs] = args;
        return t(`${keyPath}.${key}`, ...otherArgs);
    };

export const getScopedT =
    (
        keyPath: string,
        tFromUseTranslation: TFunction,
    ): TFunction<'translation', undefined> =>
    (...args: Parameters<TFunction<'translation', undefined>>) => {
        const [key, ...otherArgs] = args;
        return tFromUseTranslation(`${keyPath}.${key}`, ...otherArgs);
    };
